import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router/composables';
import {
  NavBar,
  ButtonIconContextual,
  SpinnerLoader,
  HelperViewContextual,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import { WealthPerformanceAccordions } from './components/WealthPerformanceAccordions';

import {
  getPerformanceHistoryOverview,
  IDefaultProps
} from '@/modules/wealth/services/portfolio';
import { getPerformance } from '@/modules/wealth/services/investment';


export default /*#__PURE__*/_defineComponent({
  __name: 'WealthPerformance',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const hasError = ref(false);
const isLoading = ref(false);
const historyOverview = ref<IDefaultProps[]>([]);
const updatedAt = ref('');
const portfolioId = ref('');

const isEmpty = computed(() => historyOverview.value.length === 0);
const computedIcon = computed(() => {
  return route.query.portfolio ? 'EA0030' : 'EF0030';
});

async function getWealthPerformance() {
  if (route.query.portfolio) {
    portfolioId.value = route.query.portfolio as string;
    await fetchPortfolioPerformance();
    return;
  }
  await fetchWealthPerformance();
}

async function fetchPortfolioPerformance() {
  try {
    hasError.value = false;
    isLoading.value = true;

    const data = await getPerformanceHistoryOverview(portfolioId.value);
    historyOverview.value = data.performanceHistoryOverview;
    updatedAt.value = data.updatedAt.formatted;
  } catch (error) {
    console.error(error);
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchWealthPerformance() {
  try {
    hasError.value = false;
    isLoading.value = true;

    const data = await getPerformance();
    historyOverview.value = data.performanceHistoryOverview;
    updatedAt.value = data.updatedAt.formatted;
  } catch (error) {
    console.error(error);
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

function onBack() {
  router.back();
}

onMounted(() => {
  getWealthPerformance();
});

return { __sfc: true,router, route, hasError, isLoading, historyOverview, updatedAt, portfolioId, isEmpty, computedIcon, getWealthPerformance, fetchPortfolioPerformance, fetchWealthPerformance, onBack, NavBar, ButtonIconContextual, SpinnerLoader, HelperViewContextual, HelperViewStatus, ShowMoneyToggleButton, WealthPerformanceAccordions }
}

})